import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { Dialog } from "primereact/dialog";
import BottomMessagePopUp from "../../components/BottomMessagePopUp";
import submitSuccessFul from "../../assets/images/submit-successful.png";
import submitFail from "../../assets/images/submit-failed.png";
import renewRoadTaxMyJpj from "../../assets/images/renew-road-tax-via-myjpj.png";
import mySikapLogo from "../../assets/images/mysikap-logo.png";
import loadingIcon from "../../assets/images/loading-icon.gif";

import lonpacInsurance from "../../assets/images/insurance/lonpac-insurance.png";
import etiqaInsurance from "../../assets/images/insurance/etiqa-insurance.png";
import allianz from "../../assets/images/insurance/allianz.png";
import generali from "../../assets/images/insurance/generali.png";
import tokioMarine from "../../assets/images/insurance/tokio-marine-insurance.png";
import rhbInsuracne from "../../assets/images/insurance/rhb-insurance.png";
import berjayaSompo from "../../assets/images/insurance/berjaya-sompo.png";
import takafulIkhlas from "../../assets/images/insurance/takaful-ikhlas.png";
import liberty from "../../assets/images/insurance/liberty-insurance.png";
import tuneInsurance from "../../assets/images/insurance/tune-protect.png";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getDeviceType } from "../../utils/device";

const PaymentStatus = () => {
  const [image, setImage] = useState(submitSuccessFul);
  const [message, setMessage] = useState("");
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRenewRoadTaxVisible, setIsRenewRoadTaxVisible] = useState(false);
  const [isAutoIns, setIsAutoIns] = useState(false);
  const [isViewMore, setIsViewMore] = useState(false);
  const [isViewMore2, setIsViewMore2] = useState(false);
  const [redirectType, setRedirectType] = useState(null); 

  const showErrorMessage = (msg) => {
    setErrorMessage(msg);
    setIsErrorVisible(true);
  };

  const handleToggle = () => {
    setIsViewMore((prev) => !prev);
  };

  const handleToggle2 = () => {
    setIsViewMore2((prev) => !prev);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const policyId = queryParams.get("policy_id");

  const status = queryParams.get("status");
  const referenceNo = queryParams.get("refNo");
  const amount = queryParams.get("amount");
  const roadTaxRenewal = queryParams.get("roadtaxrenewal");
  const autoIns = queryParams.get("isAutoIns");
  
  useEffect(() => {
    const userAgent = navigator.userAgent || "";

    console.log("User Agent:", userAgent);

    const isInApp = userAgent.includes("ANSA-Digital-WebView");
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    // Deep link only when opened inside your mobile app webview
    if (!isInApp && (isAndroid || isIOS)) {
      const deeplink = window.location.href.replace(
        process.env.REACT_APP_FRONTEND_URL,
        "ansa-digital://"
      );

      console.log("Redirecting to deep link:", deeplink);
      window.location.href = deeplink;
    } else {
      console.log("Not inside mobile app — skipping deep link");
    }

    // Set details for display
    if (status && referenceNo && amount) {
      setDetails({
        "Reference No": referenceNo,
        "Total Paid Amount": `RM ${String(amount)}`,
      });

      if (autoIns === "1") {
        setIsAutoIns(true);
      }

      if (status === "1") {
        // const payloads = {
        //   id: 1,
        //   status: "active",
        // };

        if (roadTaxRenewal === "1") {
          setIsModalVisible(true);
          setIsRenewRoadTaxVisible(true);
        }

        setMessage("You have successfully subscribed to your insurance/takaful plan.");
        setImage(submitSuccessFul);
      } else {
        setMessage("Your payment failed. Please try again or contact customer support.");
        setImage(submitFail);
      }
    } else {
      showErrorMessage("Payment details are missing or invalid.");
      setImage(submitFail);
      setMessage("An error occurred while processing your payment.");
    }

  }, [status, referenceNo, amount, roadTaxRenewal, autoIns]);

  useEffect(() => {
    if (!isModalVisible || !redirectType) return;
  
    const timer = setTimeout(() => {
      if (redirectType === "myjpj") {
    
        const userAgent = navigator.userAgent.toLowerCase();
        const isAndroid = userAgent.includes("android");
        const isIOS = /iphone|ipad|ipod/.test(userAgent);

        setIsModalVisible(false);
    
        if (isIOS) {
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.src = "myjpj://";
          document.body.appendChild(iframe);
    
          // iOS fallback to App Store
          setTimeout(() => {
            window.location.href =
              "https://apps.apple.com/my/app/myjpj/id6443821311";
          }, 1200);
        }
    
        else if (isAndroid) {
          window.location.href = "intent://#Intent;package=com.jpj.jpj_info;end";

          setTimeout(() => {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.jpj.jpj_info&hl=ms";
          }, 1200);
        }
    
        else {
          console.log("Desktop detected — skipping deep link");
        }
      } else if (redirectType === "mysikap") {
        setIsModalVisible(false);
        window.location.href = "https://public.jpj.gov.my/public/login.zul";
      }
    }, 500);
  
    return () => clearTimeout(timer);
  }, [isModalVisible, redirectType]);

  const handleViewPolicy = () => {
    window.ReactNativeWebView.postMessage('viewPolicies');
  };

  const handleBackButton = (e) => {
    e.preventDefault();
    window.ReactNativeWebView.postMessage('closeWebView');
  };

  const refundData = [
    { period: "Not exceeding 1 week", refund: "87.5% of the total contribution/premium" },
    { period: "Not exceeding 1 month", refund: "75.0% of the total contribution/premium" },
    { period: "Not exceeding 2 months", refund: "62.5% of the total contribution/premium" },
    { period: "Not exceeding 3 months", refund: "50.0% of the total contribution/premium" },
    { period: "Not exceeding 4 months", refund: "37.5% of the total contribution/premium" },
    { period: "Not exceeding 6 months", refund: "25.0% of the total contribution/premium" },
    { period: "Not exceeding 8 months", refund: "12.5% of the total contribution/premium" },
    { period: "Exceeding 8 months", refund: "No refund of contribution/premium allowed" },
  ];

  return (
    <div className="content">
      <div className="get-quote-process-container justify-content-between" style={{ flexDirection: "row", alignContent: "space-between" }}>
        <div className="get-quote-container d-m-column p-0">
          <div className="filters d-flex flex-column justify-content-center align-items-center w-100 mt-6">
            <Image className="mr-2" src={image} height={80} width={80} />
            <h3>{status === "1" ? "Successful Payment" : "Payment Summary"}</h3>
            <span className="formatted-text text-center">{message}</span>
          </div>
          <div className="car-details-block border-radius-25 mt-4 p-20 w-100">
            <div className="grid d-flex w-100">
              <div className="col-lg-6 text-left p-2">
                {Object.entries(details).map(([key, value]) => (
                  <div
                    key={key}
                    className="d-flex justify-content-between align-items-center pb-2"
                  >
                    <div className="vw-50 text-left">
                      <span className="formatted-text" style={{ fontSize: "16px" }}>
                        {key}
                      </span>
                    </div>
                    <div className="vw-50 text-right">
                      <span
                        className="fw-medium color-heading"
                        style={{ color: "#000", fontSize: "16px" }}
                      >
                        {value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <span className="formatted-text mt-2" style={{fontSize: "0.7rem"}}>*Please refer to the Product Disclosure Sheet or Policy Wording for cancellation and refund policy.</span>

          {isAutoIns && (
          <>
          <div className="car-details-block-inline border-radius-25 mt-2 p-20 w-100">
            <span className="formatted-text" style={{fontSize: "0.7rem"}}>
              {`Thank you for selecting us as the registered financial advisor of the insurance company below:`}
            </span>
            
            <div>
							<div className="d-flex justify-content-between align-items-center my-3">
								<img
                  src={lonpacInsurance}
                  alt="Lonpac Insurance"
                  className="mx-2"
                  style={{ width: "100px", height: "auto" }}
                />
                <img
                  src={etiqaInsurance}
                  alt="Etiqa Insurance"
                  className="mx-2"
                  style={{ width: "80px", height: "auto" }}
								/>
                <img
                  src={allianz}
                  alt="Allianz"
                  className="mx-2"
                  style={{ width: "80px", height: "auto" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center my-3">
                <img
                  src={generali}
                  alt="Generali"
                  className="mx-2"
                  style={{ width: "50px", height: "auto" }}
                />
                <img
                  src={tokioMarine}
                  alt="Tokio Marine"
                  className="mx-2"
                  style={{ width: "auto", height: "30px" }}
                />
                <img
                  src={rhbInsuracne}
                  alt="RHB Insurance"
                  className="mx-2"
                  style={{ width: "auto", height: "18px" }}
                />
              </div>

              <div className="d-flex justify-content-start align-items-center my-3">
                <img
                  src={berjayaSompo}
                  alt="Berjaya Sompo"
                  className="mx-2"
                  style={{ width: "auto", height: "40px" }}
                />
                <img
                  src={tuneInsurance}
                  alt="Tune Protect"
                  className="mx-2"
                  style={{ width: "auto", height: "40px" }}
                />
                <img
                  src={liberty}
                  alt="Liberty"
                  className="mx-2"
                  style={{ width: "auto", height: "40px" }}
                />
              </div>
            </div>

            <span className="formatted-text" style={{fontSize: "0.7rem"}}>
              {`a. During term/coverage of insurance, the policyholder/takaful participant is eligible to request for insurance cancellation 
              via email to Advance Fin Advisory Sdn Bhd. Refund of premium/contribution amount (excluding stamp duty paid) will 
              depend on the remaining number of months until the end of insurance term/coverage period. Kindly refer to 
              the table below for further details.`}
            </span>

            {isViewMore && (
              <>
                <hr/>

                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`b. Policyholder/takaful participant(s) eligible for cancellation refund are required to provide their own bank account 
                  details for refund to be credited by the respective insurer.`}
                </span>

                <hr/>

                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`c. Refund may take up to 21 working days from date of cancellation request.`}
                </span>

                <hr/>

                <DataTable
                  value={refundData}
                  className="refund-table text-sm border border-gray-300"
                  tableStyle={{  }}
                >
                  <Column field="period" header="Period of Takaful/Insurance"></Column>
                  <Column field="refund" header="Refund of Contribution/Premium"></Column>
                </DataTable>
              </>
            )}

            <Button
              style={{ width: "auto" }}
              className="btn-secondary fw-bold"
              label={isViewMore ? "View Less" : "View More"}
              icon={isViewMore ? "pi pi-chevron-up" : "pi pi-chevron-right"}
              iconPos="right"
              onClick={handleToggle}
            />
          </div>

          <div className="car-details-block-inline border-radius-25 mt-2 p-20 w-100">
            <div className="d-flex justify-content-between align-items-center pb-2 w-100">
							<div className="w-50text-left">
								<span className="color-heading fw-medium">
									{"Takaful"}
								</span>
							</div>
							<div className="vw-50 text-right">
                <img
                  src={takafulIkhlas}
                  alt="Takaful Ikhlas"
                  className="mx-2"
                  style={{ width: "auto", height: "40px" }}
                />
							</div>
						</div>
                
            <span
              className="formatted-text text-left"
              style={{ fontSize: "0.7rem" }}
              dangerouslySetInnerHTML={{
                __html: "Cancellation\nEither You or Takaful operator may cancel this Certificate at any time during the Period of Takaful."
                  .replace(/\n/g, "<br />"),
              }}
            ></span>

            {isViewMore2 && (
              <>
                <hr/>
                <span
                  className="formatted-text text-left"
                  style={{ fontSize: "0.7rem" }}
                  dangerouslySetInnerHTML={{
                    __html: `a. Cancellation by You:\nYou can cancel this Certificate at any time by returning the Certificate of Takaful (CT) to TIGB or, if the CT has been lost or destroyed, You must provide Takaful operator with a duly certified Statutory Declaration (SD) to confirm this.`
                      .replace(/\n/g, "<br />"),
                  }}
                ></span>
                <hr/>
                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`After returning the CT or SD, You will be entitled to a refund of contribution if no claim was incurred 
                  prior to cancellation. Your refund will be the pro rata contribution for the unexpired period of cover 
                  calculated from the date Takaful operator receives the CT or SD.`}
                </span>
                <hr/>
                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`You will be subject to a cancellation fee of RM10.00 upon Your request to cancel the CT.`}
                </span>
                <hr/>
                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`Takaful operator will retain at least RM50.00 of the total contribution as the Minimum 
                  Contribution required.`}
                </span>
                <hr/>
                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`The Certificate will automatically lapse once You sell or dispose of Your Car because Your 
                  permissible Takaful interest in the Car will cease. If You want to transfer the Certificate 
                  to the new buyer, You have to get Takaful operator’s prior consent.`}
                </span>

                <hr/>
                <span
                  className="formatted-text text-left"
                  style={{ fontSize: "0.7rem" }}
                  dangerouslySetInnerHTML={{
                    __html: `b. Cancellation by Takaful operator:\nTakaful provider may also cancel this Certificate by giving You fourteen (14) days' notice in writing by registered post to Your last address known to Takaful operator.`
                      .replace(/\n/g, "<br />"),
                  }}
                ></span>
                <hr/>
                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`After returning the CT or SD, You will be entitled to a refund of contribution for the unexpired 
                  period calculated on a pro-rata basis from the date Takaful operator receives the CT or SD from 
                  You to the expiry date of the Certificate.`}
                </span>
                <hr/>
                <span className="formatted-text" style={{fontSize: "0.7rem"}}>
                  {`There will not be any refund of contribution for any cancellation of Certificate (either by You 
                    or by Takaful operator) if You have paid the Minimum Contribution only or if a claim has been 
                    made on this Certificate.`}
                </span>
              </>
            )}

            <Button
              style={{ width: "auto" }}
              className="btn-secondary fw-bold"
              label={isViewMore2 ? "View Less" : "View More"}
              icon={isViewMore2 ? "pi pi-chevron-up" : "pi pi-chevron-right"}
              iconPos="right"
              onClick={handleToggle2}
            />
          </div>
          </>
          )}

          {isRenewRoadTaxVisible && (
            <div>
              <p>Add On</p>
              <div className="flex justify-content-between pl-4 pr-4 pt-2 pb-3 add-on align-items-center">
                <div>
                  <p>Would you also like to <b>renew road tax?</b></p>
                  <Button
                    className="btn-renew-road-tax"
                    onClick={() => { setIsModalVisible(true) }}
                  >
                    Renew RoadTax
                  </Button>
                </div>

                <img src={renewRoadTaxMyJpj} alt="" />
              </div>
            </div>
          )}
        </div>

        {status === "1" && (
          <>
            <div 
              className="car-details-block-inline border-radius-25 mt-2 p-20 w-100 align-items-center"
              style={{
                textAlign: "left"
              }}
            >
              <p>Would you also like to <b>renew road tax?</b></p>
              <div
                className="d-flex flex-column align-items-center w-100"
                style={{
                  textAlign: "center"
                }}
              >
                <Button
                  className="btn-renew-road-tax"
                  onClick={() => { 
                    setRedirectType("myjpj");
                    setIsModalVisible(true); 
                  }}
                >
                  Renew Road Tax via MyJPJ
                </Button>

                <p>or</p>
                
                <Button
                  className="btn-renew-road-tax"
                  onClick={() => { 
                    setRedirectType("mysikap");
                    setIsModalVisible(true); 
                  }}
                >
                  Renew Road Tax via MySikap
                </Button>
              </div>
            </div>
          </>
        )}

        {isModalVisible && (
          <Dialog
            className="filter-modal d-flex flex-row bg-white p-20 justify-content-center align-items-center pop-box"
            modal
            header={`Header`}
            visible={isModalVisible}
            position={"center"}
            content={({ hide }) => (
              <>
                <button
                  type="button"
                  className="p-dialog-header-icon p-dialog-header-close p-link"
                  data-pc-section="closebutton"
                  onClick={() => { setIsModalVisible(false) }}
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="p-icon p-dialog-header-close-icon" aria-hidden="true" data-pc-section="closebuttonicon">
                    <path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path>
                  </svg>
                </button>

                <div className="filters">
                  <div className="d-flex items-center justify-content-center gap-2">
                    <img 
                      className="renew-road-tax-img" 
                      src={redirectType === "myjpj" ? renewRoadTaxMyJpj : mySikapLogo} 
                      alt="" 
                      style={{
                        width: redirectType === "myjpj" ? "80px": "150px",
                        height: "auto"
                      }}
                    />
                    <div>
                      <p className="text-w">{`We are directing you to ${redirectType === "myjpj" ? "MyJPJ app": "MySikap website"}, please wait patiently...`}</p>
                    </div>

                    <img
                      style={{ width: 50, height: 50 }}
                      src={loadingIcon}
                      alt="Loading"
                    />
                  </div>
                </div>
              </>
            )}
          ></Dialog>
        )}

        <div className="pt-4 pb-4 w-100">
          {status === "1" ? (
            <>
              <Button
                  className="btn-primary fw-bold"
                  label="View Policy/Summary"
                  loading={loading}
                  onClick={handleViewPolicy}
              />
              <Button
                  className="btn-secondary fw-bold"
                  label="Back to Home"
                  onClick={(e) => handleBackButton(e)}
              />
            </>
          ) : (
            <>
              <Button
                  className="btn-primary fw-bold mb-2"
                  label="Back to Home"
                  loading={loading}
                  onClick={handleBackButton}
              />
              <div className="help-text text-center mt-2">
                  Need Help? Contact{" "}
                  <a href="/ansa-help" className="color-primary text-decoration-none">
                      ANSA Help Now!
                  </a>
              </div>
            </>
          )}
        </div>

        <BottomMessagePopUp
          message={errorMessage}
          type="error"
          isVisible={isErrorVisible}
          onClose={() => setIsErrorVisible(false)}
        />
      </div>
    </div>
  );
};

export default PaymentStatus;
